export default __webpack_public_path__ + "static/card-7-d16547d041391e27605051759afce254.png";